/**
 * Turn a horizon suffix slug into readable label text (e.g. rsmg_sales → Rsmg Sales).
 */
export function formatHorizonSlug(slug) {
  const raw = String(slug || '').trim();
  if (!raw) return '';

  return raw
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Display label for a horizon row or slug string.
 * Uses description when present; otherwise formats the suffix slug.
 */
export function horizonDisplayLabel(horizonOrSlug, fallbackSuffix = '') {
  if (horizonOrSlug && typeof horizonOrSlug === 'object') {
    const desc = String(horizonOrSlug.description || '').trim();
    if (desc) return desc;
    return formatHorizonSlug(horizonOrSlug.suffix || fallbackSuffix);
  }
  return formatHorizonSlug(horizonOrSlug || fallbackSuffix);
}
